import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { UsersState } from 'contexts/usersContext/UsersState';
import { Header } from './Header';
import { ShellProvider } from './ShellProvider';
import { Sidebar } from './Sidebar';

/** Estructura de todas las pantallas autenticadas: barra lateral, cabecera y contenido. */
const Layout = memo(() => (
	<ShellProvider>
		<UsersState>
			<div className="bg-background text-foreground flex h-screen w-full overflow-hidden">
				<Sidebar />
				<div className="flex min-w-0 flex-1 flex-col">
					<Header />
					<main
						id="contenido"
						className="min-h-0 flex-1 overflow-y-auto p-6">
						<Outlet />
					</main>
				</div>
			</div>
		</UsersState>
	</ShellProvider>
));

Layout.displayName = 'Layout';

export { Layout };
